import { Grid } from '@chakra-ui/react';
import { PLATFORM_OPTIONS } from '~/screens/MyAgency/components/PlatformsToggle';
import { SelectButton } from '~/screens/MyAgency/components/utils';
import { useAdvancedFiltersStore } from '~/screens/MyAgency/store';
import {
  FILTERS,
  IGFilters,
  TikTokFilters,
  YouTubeFilters,
} from '~/screens/MyAgency/types';
import { convertPxToRems } from '~/utils-ts';

const genders = ['Male', 'Female'];

const GendersMap = {
  [PLATFORM_OPTIONS.selectPlatform]: genders,
  [PLATFORM_OPTIONS.instagram]: genders,
  [PLATFORM_OPTIONS.tiktok]: [...genders, 'Other'],
  [PLATFORM_OPTIONS.youtube]: genders,
  [PLATFORM_OPTIONS.snapchat]: [...genders, 'Unknown'],
};

export const GenderInput: React.FC = () => {
  const { activePlatform, setFilter, getFilter } = useAdvancedFiltersStore();

  const selectedGender = getFilter(activePlatform, FILTERS.gender);

  return (
    <Grid
      templateColumns={`repeat(${GendersMap[activePlatform].length}, 1fr)`}
      gap="4px"
      marginTop={convertPxToRems(16)}
    >
      {GendersMap[activePlatform].map((gender) => (
        <SelectButton
          key={gender}
          value={gender}
          isSelected={selectedGender === gender}
          isDisabled={
            (activePlatform as string) === PLATFORM_OPTIONS.selectPlatform
          }
          onSelect={(
            value:
              | IGFilters['gender']
              | TikTokFilters['gender']
              | YouTubeFilters['gender'],
          ) => setFilter(activePlatform, FILTERS.gender, value)}
        />
      ))}
    </Grid>
  );
};
